import React, { useState } from 'react';
import AddReactionsIcon from '@shared/assets/icons/v2/add-reactions.svg';
import { MBAnimation } from '@shared/components/animation';
import { MBHover } from '@shared/components/hover';
import { MBIcon } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { Colors } from '@shared/styles';
import { Styles } from './styles';

export interface MBReactionButtonProps {
  onPress(): void;
  testID?: string;
}

/*
    A button to add reactions. This houses no logic (like showing the reaction picker).
    It is simply a button.
*/
export function MBReactionButton({ onPress, testID }: MBReactionButtonProps) {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  return (
    <MBTouchableOpacity onPress={onPress} testID={testID}>
      <MBHover onHoverStart={() => setIsHovered(true)} onHoverEnd={() => setIsHovered(false)}>
        <MBAnimation scale={{ from: 1, to: 1.15 }} disabled={!isHovered} type="spring">
          <MBIcon
            color={Colors.v2.gray30}
            style={Styles.reactionButtonIcon}
            source={AddReactionsIcon}
          />
        </MBAnimation>
      </MBHover>
    </MBTouchableOpacity>
  );
}
